/**
 * Pattern Insights API Service
 * Fetches pattern recognition and AI-powered business insights.
 *
 * Migrated to central `apiClient` (cookie auth, CSRF, JSON parsing,
 * 401 redirect) — replaces the inline `window.__corvanaNativeFetch`
 * dance previously duplicated per service.
 */
import { apiClient } from '@/lib/apiClient';
import { logIfReal } from '@/utils/transientError';

const safe = async (label, promise) => {
  try {
    return await promise;
  } catch (error) {
    logIfReal(label, error);
    return null;
  }
};

export const getSeasonalPattern = (industry, month = null) => {
  const params = new URLSearchParams({ industry });
  if (month) params.append('month', month);
  return safe('Seasonal pattern', apiClient.get(`/api/insights/seasonal-pattern?${params}`));
};

export const getDashboardPatternInsights = (businessId, businessName, industry, metrics) =>
  safe('Dashboard pattern insights', apiClient.post('/api/insights/dashboard-pattern-insights', {
    business_id: businessId,
    business_name: businessName,
    industry,
    metrics,
  }));

export const getProactiveTips = (industry, currentRevenueChange = 0) => {
  const params = new URLSearchParams({
    industry,
    current_revenue_change: currentRevenueChange.toString(),
  });
  return safe('Proactive tips', apiClient.get(`/api/insights/proactive-tips?${params}`));
};

export const analyzeMetricPattern = (metricName, currentValue, previousValue, industry) =>
  safe('Metric pattern analysis', apiClient.post(
    `/api/insights/analyze-metric-pattern?industry=${industry}`,
    {
      metric_name: metricName,
      current_value: currentValue,
      previous_value: previousValue,
    },
  ));
